<template>
  <div :class="'md-layout'">
    <div
     :class="['md-layout-item md-size-100', { 'is-disabled-wrapper': isDisabled }]"
    >
      <md-datepicker
        :class="{ 'is-disabled-input': isDisabled }"
        md-immediately
        v-model="field"
        @md-closed="send"
      >
        <label v-bind:style="answered ? '' : 'color: #ef4225 !important;' ">{{ question.text }}</label>
      </md-datepicker>
    </div>
    <div :class="'md-layout-item md-size-100'">
      <md-field>
        <label>Observation</label>
        <md-input
          type="text"
          v-model="observation"
          :disabled="isDisabled"
          :maxlength="100"
          @blur.prevent="send"
        />
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    answer: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    answered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      field: "",
      observation: "",
    };
  },
  methods: {
    send() {
      this.$nextTick(() => {
        const id = this.$route.params.id;
        const data = this.getAnswer();

        if (data.answers[0].answer === null) return;

        this.$api.request
          .post(`reviews/${id}/answers`, data)
          .then((response) => {
            this.$emit("post-sent", {
              question: this.question.id || response.data[0]["question_id"],
            });
          })
          .catch(() => {
            this.$toast.warning("Please, try again.", "");
          });
      });
    },
    getAnswer() {
      return {
        section: this.getSection(),
        type: this.question.type,
        answers: [
          {
            question_id: this.question.id,
            answer: this.field,
            text: this.observation,
          },
        ],
      };
    },
    getSection() {
      switch (this.$parent.mdLabel) {
        case "Engagement Leader":
          return "engagement_leader";
        case "Manager":
          return "manager";
        default:
          return "reviewer";
      }
    },
  },
  mounted() {
    this.field = this.answer.answer;
    this.observation = this.answer.text;
  },
};
</script>

<style lang="sass">
.is-disabled-input
  pointer-events: none

  .is-disabled-wrapper
    cursor: not-allowed
    button.md-button.md-clear
      display: none
</style>
